import { render, staticRenderFns } from "./MatchRecipesWantsoft.vue?vue&type=template&id=07c6b0c2&"
import script from "./MatchRecipesWantsoft.vue?vue&type=script&lang=js&"
export * from "./MatchRecipesWantsoft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports